import { getScrollbarWidth } from "@otto-ec/global-resources/viewport";

/**
 *
 */

export async function disableScrolling(): Promise<void> {
  const { style } = document.documentElement;
  style.marginRight = `${await getScrollbarWidth()}px`;
  style.overflow = "hidden";
}

export function enableScrolling(): void {
  const { style } = document.documentElement;
  style.removeProperty("overflow");
  style.removeProperty("margin-right");
}
